module.exports = __webpack_public_path__ + "img/wardInfoBlackBrown.6918e348.svg";